import { CorrespondenceDepartmentFunctionDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrespondenceFunctionService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCorrespondenceFunction(): Observable<
    CorrespondenceDepartmentFunctionDto[]
  > {
    return this.http.get<CorrespondenceDepartmentFunctionDto[]>(
      this.url + 'correspondence-department-function'
    );
  }

  createCorrespondenceFunction(
    data: CorrespondenceDepartmentFunctionDto[]
  ): Observable<CorrespondenceDepartmentFunctionDto[]> {
    return this.http.post<CorrespondenceDepartmentFunctionDto[]>(
      this.url + 'correspondence-department-function',
      data
    );
  }
  getSingleCorrespondenceFunction(id: string): Observable<any> {
    return this.http.get(this.url + 'correspondence-department-function/' + id);
  }

  updateCorrespondenceFunction(
    data: CorrespondenceDepartmentFunctionDto[]
  ): Observable<CorrespondenceDepartmentFunctionDto[]> {
    return this.http.post<CorrespondenceDepartmentFunctionDto[]>(
      this.url + 'correspondence-department-function/update',
      data
    );
  }

  deleteCorrespondenceFunction(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append(
      'correspondence-department-function',
      ids.join(', ')
    );
    return this.http.delete(
      this.url + 'correspondence-department-function',
      httpOptions
    );
  }
}
